@let prices = destinationCode() | finCheapestPricePipe: originLocationCode() | async;
@let selectedOriginName = selectedOriginLocationName();

<section class="hero" [class.pr-small-t]="!isNewBrand()" [class.ps-medium-t]="isNewBrand()">
  <div class="hero__top grid-col-12 grid-max-width no-row-gap" [class.ps-medium-b]="isNewBrand()">
    @if (isNewBrand()) {
      <ng-container *ngTemplateOutlet="newBrandHeader" />
    } @else {
      <ng-container *ngTemplateOutlet="legacyHeader" />
    }
  </div>
  <cms-full-width-booking-widget
    [backgroundImage]="backgroundImage()"
    [locations]="[{ originLocationCode: originLocationCodeFromStore(), destinationLocationCode: destinationCode() }]"
    [enableAward]="enableAward()"
    [enableAurinkomatkat]="enableAurinkomatkat()"
    [enablePromoCode]="enablePromoCode()"
    [contentType]="contentType()"
  />
</section>

<ng-template #legacyHeader>
  <div class="hero__top-left mr-medium-b col-1-12 sm-col-1-6 flex--self-start">
    <h1 data-testid="destination-hero-title" class="font-heading-3 font-headline-small">
      <div class="hero__top-lead font-body-1 nordic-blue-900-text text-icon-primary light-type font-body-medium">
        {{ 'flightsTo' | finLocalization }}
      </div>
      <div class="hero__top-destination font-heading-1 nordic-blue-900-text text-icon-primary font-headline-medium">
        {{ title() }}
      </div>
    </h1>
  </div>
  @if (prices) {
    <div class="hero__top-right promo mr-medium-b col-1-12 sm-col-7-12">
      @if (selectedOriginName) {
        <div class="flex bold-type" data-testid="hero-promo-best-price-container">
          <div [class.promo__prices-wrapper]="!isInCampaign()">
            @if (!isInCampaign()) {
              <div
                class="font-body-1 nordic-blue-900-text text-icon-primary font-body-medium"
                data-testid="hero-promo-best-price-label"
              >
                {{ 'economyClass' | finLocalization }}
              </div>
            } @else {
              <div
                class="font-body-1 white-text text-icon-reversed font-body-medium"
                [class.black-bg]="enableBlackTeaser()"
                [class.surface-contrast]="enableBlackTeaser()"
                [class.heather-700-bg]="!enableBlackTeaser()"
                [class.surface-accent]="!enableBlackTeaser()"
                data-testid="hero-campaign-badge"
              >
                <p class="ps-xsmall">
                  {{ campaignLabel() }}
                  {{ campaignEndText() }}
                </p>
              </div>
            }
            <div class="promo__prices grid-col-12 ps-xxsmall-t ps-clear-x no-row-gap" [class.campaign]="isInCampaign()">
              @if (showOneWayPrice()) {
                <ng-container
                  *ngTemplateOutlet="
                    pricePromo;
                    context: {
                      price: prices[TripType.ONEWAY],
                      type: CmsTripTypeMap[TripType.ONEWAY],
                      isInCampaign: isInCampaign(),
                    }
                  "
                />
              }
              <ng-container
                *ngTemplateOutlet="
                  pricePromo;
                  context: {
                    price: prices[TripType.RETURN],
                    type: CmsTripTypeMap[TripType.RETURN],
                    isInCampaign: isInCampaign(),
                  }
                "
              />
            </div>
          </div>
        </div>
        <div class="light-type font-body-2 ms-xxsmall-t nordic-blue-900-text text-icon-primary font-body-small">
          {{ 'destinationSearch.bestFareForThisDestination' | finLocalization: { origin: selectedOriginName } }}
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #newBrandHeader>
  @if (isInCampaign()) {
    <fcom-tag
      data-testid="destination-hero-campaign-tag"
      class="pr-xsmall-b col-1-12"
      [theme]="enableBlackTeaser() ? TagTheme.BLACK_FRIDAY : TagTheme.PROMOTION"
    >
      <p>
        {{ campaignLabel() }}
        {{ campaignEndText() }}
      </p>
    </fcom-tag>
  }
  <div class="hero__top-wrapper col-1-12 flex mobile-column">
    <div class="hero__top-left">
      <h1 data-testid="destination-hero-title" class="hero__top-title font-heading-3 font-headline-small">
        <div class="hero__top-lead text-icon-primary font-body-small">
          {{ 'flightsTo' | finLocalization }}
        </div>
        <div class="hero__top-destination text-icon-primary font-headline-medium font-expressive">
          {{ title() }}
        </div>
      </h1>
      <div class="text-icon-primary font-body-small">
        {{ 'destinationSearch.fromOrigin' | finLocalization: { origin: selectedOriginName } }}
      </div>
    </div>
    @if (prices) {
      <div class="hero__top-right">
        @if (selectedOriginName) {
          <div
            class="promo__prices flex ps-clear-x"
            data-testid="hero-promo-best-price-container"
            [class.campaign]="isInCampaign()"
            [class.ps-xxsmall-t]="!isNewBrand()"
          >
            @if (showOneWayPrice()) {
              <ng-container
                *ngTemplateOutlet="
                  pricePromo;
                  context: {
                    price: prices[TripType.ONEWAY],
                    type: CmsTripTypeMap[TripType.ONEWAY],
                    isInCampaign: isInCampaign(),
                  }
                "
              />
            }
            <ng-container
              *ngTemplateOutlet="
                pricePromo;
                context: {
                  price: prices[TripType.RETURN],
                  type: CmsTripTypeMap[TripType.RETURN],
                  isInCampaign: isInCampaign(),
                }
              "
            />
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #pricePromo let-price="price" let-type="type" let-isInCampaign="isInCampaign">
  @if (price && type) {
    <div class="price-promo-text" [class.ps-xxsmall-t]="!isNewBrand()">
      <div
        class="promo__price-from font-body-2 nordic-blue-900-text text-icon-primary font-body-small"
        [class.light-type]="!isNewBrand()"
        [class.align-right]="!isInCampaign && !isNewBrand()"
      >
        <div>{{ 'travelType.from.' + type | finLocalization }}</div>
        @if (isNewBrand()) {
          <div
            class="price-promo-value flex flex--self-center font-headline-medium"
            [class.text-icon-accent]="isInCampaign"
            [class.text-icon-primary]="!isInCampaign"
            [attr.data-testid]="'hero-price-' + type"
          >
            {{ price | finPrice: { roundPrice: true } }}
          </div>
        }
      </div>
    </div>
    @if (!isNewBrand()) {
      <div
        class="price-promo-value heather-700-text text-icon-primary font-heading-3 flex flex--self-center font-headline-small"
        [attr.data-testid]="'hero-price-' + type"
      >
        {{ price | finPrice: { roundPrice: true } }}
      </div>
    }
  }
</ng-template>
